import {MithrilComponent} from '@bitstillery/mithril'
import {CampaignPreferences} from '@bitstillery/common/components/portal'
import {classes} from '@bitstillery/common/lib/utils'
import {$t} from '@bitstillery/common/app'
import m from '@bitstillery/mithril'

import {$s} from '@/app'

// @i18n include: shell.title.my_portal_email
// @i18n include: shell.description.my_portal_email
export class MyPortalEmail extends MithrilComponent {
    view(_vn: m.Vnode) {
        return (
            <div
                className={classes('c-my-portal-email', {
                    'flex-form': $s.identity.token,
                    form: !$s.identity.token,
                    landing: !$s.identity.token,
                })}
            >
                {$s.identity.token && <h3 className='tile-container-title'>{$t('my_portal.email_label')}</h3>}
                <div className='fieldset'>
                    <div className='step'>
                        {!$s.identity.token && <h3>{$t('my_portal.email_label')}</h3>}

                        <CampaignPreferences portal_action_buttons />
                    </div>
                </div>
            </div>
        )
    }
}
